import * as types from '../mutation_types';
import router from '@views/home/router';
import axios from 'axios';

const debug = false;
const debugGetRooms = debug;

export default {
  getRooms({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      let call;
      if (debugGetRooms) {
        call = import('@fixtures/rooms-fixture');
      } else {
        const token = router.app.$context.token;
        call = axios.get(`/api/v1/room-plant/?device_size=${payload.device_size}&date=${payload.date}`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        dispatch('rooms/setRooms', response.data, {root: true});
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setRooms({commit}, payload) {
    return new Promise((resolve, reject) => {
      try {
        commit(types.SET_ROOMS, payload);
        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  }
};
